import { Component, computed, inject, input, output } from '@angular/core';
import type { ModalAction } from '@purolator/ui-kit-angular';
import { ModalComponent, TypographyComponent } from '@purolator/ui-kit-angular';
import { TranslationService, TranslatePipe } from '../../../../core/i18n';

/**
 * How-to-measure dialog with Box, Envelope, Polymailer, and Tube illustrations.
 */
@Component({
  selector: 'app-how-to-measure-dialog',
  imports: [ModalComponent, TypographyComponent, TranslatePipe],
  templateUrl: './how-to-measure-dialog.html',
  styleUrl: './how-to-measure-dialog.scss',
})
export class HowToMeasureDialog {
  private readonly translation = inject(TranslationService);

  readonly open = input(false);
  readonly closed = output<void>();

  protected readonly measureItems = [
    {
      titleKey: 'createShipment.packageStep.measureModal.box',
      altKey: 'createShipment.packageStep.measureModal.boxAlt',
      imagePath: 'assets/images/package-step/measure-box.svg',
    },
    {
      titleKey: 'createShipment.packageStep.measureModal.envelope',
      altKey: 'createShipment.packageStep.measureModal.envelopeAlt',
      imagePath: 'assets/images/package-step/measure-envelope.svg',
    },
    {
      titleKey: 'createShipment.packageStep.measureModal.polymailer',
      altKey: 'createShipment.packageStep.measureModal.polymailerAlt',
      imagePath: 'assets/images/package-step/measure-polymailer.svg',
    },
    {
      titleKey: 'createShipment.packageStep.measureModal.tube',
      altKey: 'createShipment.packageStep.measureModal.tubeAlt',
      imagePath: 'assets/images/package-step/measure-tube.svg',
    },
  ] as const;

  protected readonly modalTitle = computed(() =>
    this.translation.translate('createShipment.packageStep.measureModal.title'),
  );

  protected readonly closeActions = computed<ModalAction[]>(() => [
    {
      label: this.translation.translate('createShipment.packageStep.measureModal.close'),
      variant: 'primary',
      onClick: () => this.onClose(),
    },
  ]);

  /**
   * Emits when the dialog should close.
   */
  protected onClose(): void {
    this.closed.emit();
  }
}
